import { PreordersOrder } from 'src/views/procurement/pre-orders-view/model/main'
import { permissionAtom } from './permission-atom'

export function filterAllowedOrders(orders: Array<PreordersOrder>): Array<PreordersOrder> {
  const { allowedWarehouseIdsSet } = permissionAtom.getState()

  return orders
    .filter(({ provider }) => !provider || allowedWarehouseIdsSet.has(provider))
}
